import { render, staticRenderFns } from "./guangzEditClassHB.vue?vue&type=template&id=523f3bc4&scoped=true"
import script from "./guangzEditClassHB.vue?vue&type=script&lang=js"
export * from "./guangzEditClassHB.vue?vue&type=script&lang=js"
import style0 from "./guangzEditClassHB.vue?vue&type=style&index=0&id=523f3bc4&prod&lang=less"
import style1 from "./guangzEditClassHB.vue?vue&type=style&index=1&id=523f3bc4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523f3bc4",
  null
  
)

export default component.exports